export enum TourStatusesEnum {
  AVAILABLE = 'AVAILABLE',
  FINISHED = 'FINISHED',
  BLOCKED = 'BLOCKED'
}
